import { Avatar, Box, Chip, styled } from '@mui/material';

export const StyledLessonViewWrap = styled('div')(() => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
	borderRadius: '20px',
	padding: '8px 8px 28px 8px',
	border: '1px solid #EFF2F5',
	background: 'rgba(255, 255, 255, 0.50)',
	boxShadow: '0 0 30px 0 rgba(130, 125, 131, 0.15)',
}));

export const StyledLessonHeader = styled(Box)(() => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
}));

export const StyledLessonTitle = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'column',
	gap: 4,
	alignItems: 'center',
	minWidth: 0,
}));

export const StyledLessonCard = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'column',
	padding: '12px',
	borderRadius: '16px',
	background: '#fff',
	boxShadow: '0 0 30px 0 rgba(130, 125, 131, 0.1)',
	gap: '8px',
}));

export const StyledLessonStatus = styled(Chip)(() => ({
	height: 28,
	fontWeight: 600,
}));

export const StyledLessonGrades = styled('div')(() => ({
	display: 'grid',
	gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
	gap: 12,
}));

export const StyledLessonGradeItem = styled('div')(() => ({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	padding: '8px 10px',
	borderRadius: '12px',
	background: '#fff',
}));

export const StyledLessonGradeCircle = styled('div')(() => ({
	minWidth: '36px',
	height: '36px',
	borderRadius: '50%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	color: '#fff',
	fontWeight: 700,
	fontSize: 16,
	background: 'linear-gradient(180deg, #7DB2FF 0%, #5A9CFF 100%)',
}));

export const StyledLessonTeacher = styled('div')(() => ({
	display: 'flex',
	alignItems: 'center',
	gap: 12,
}));

export const StyledLessonTeacherAvatar = styled(Avatar)(() => ({
	width: 44,
	height: 44,
}));
